import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { FilterValueType } from '../../filtered-search.component';

@Component({
  selector: 'selection-filter',
  styleUrl: '../filtered-search-option.component.scss',
  template: `
    <mat-form-field
      class="filter-form"
      appearance="outline"
      (click)="$event.stopPropagation(); $event.preventDefault()"
      (keyup)="$event.stopPropagation(); $event.preventDefault()"
    >
      <mat-label>
        {{ 'Filter.Value' | translate: locale.language }}
      </mat-label>
      <mat-select [formControl]="control" [attr.data-test]="'filter-select'">
        @for (option of values; track $index) {
          <mat-option [value]="option" [attr.data-test]="'filter-select-option-' + option">{{ option }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SelectionFilterComponent {
  @Input() control: FormControl<FilterValueType>;
  @Input() values: string[] | { value: unknown, label: string, icon?: string }[];

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
